let Ajv = require("ajv");
let ajv = new Ajv({ allErrors: true, jsonPointers: true });
require("ajv-errors")(ajv, { singleError: true });

export const validateInput = (schema: any, elements: string | object): any => {
    ajv.validate(schema, elements);
    return ajv.errors;
};
